import { RoundedSizeMapped } from "./types"

const classes = {
  base: ["", "rounded"],
  xs: ["xs:rounded-none", "xs:rounded"],
  sm: ["sm:rounded-none", "sm:rounded"],
  md: ["md:rounded-none", "md:rounded"],
  lg: ["lg:rounded-none", "lg:rounded"],
  xl: ["xl:rounded-none", "xl:rounded"],
}

export default function getRoundedClasses(
  rounded: boolean | [boolean, RoundedSizeMapped],
) {
  const hasRoundedBreakpoints = Array.isArray(rounded)
  const baseRoundedValue = hasRoundedBreakpoints ? rounded[0] : rounded
  const roundedBpValues = hasRoundedBreakpoints ? rounded[1] : undefined

  return [
    baseRoundedValue && classes.base[baseRoundedValue ? 1 : 0],
    roundedBpValues?.xs !== undefined && classes.xs[roundedBpValues.xs ? 1 : 0],
    roundedBpValues?.sm !== undefined && classes.sm[roundedBpValues.sm ? 1 : 0],
    roundedBpValues?.md !== undefined && classes.md[roundedBpValues.md ? 1 : 0],
    roundedBpValues?.lg !== undefined && classes.lg[roundedBpValues.lg ? 1 : 0],
    roundedBpValues?.xl !== undefined && classes.xl[roundedBpValues.xl ? 1 : 0],
  ]
}
